import githubLogo from "assets/images/languages/github.png";
import scrapy from "assets/images/languages/scrapy.png";

import pythonLogo from "assets/images/languages/python.png";
import reactLogo from "assets/images/languages/react.png";
import aws from "assets/images/languages/aws.png";
import {FaSpider} from 'react-icons/fa'
export default {
  stack: [
    {
      name: "github",
      url: "https://github.com/",
      imageSrc: githubLogo,
    },
    {
      name: "Python",
      url: "https://www.python.org/",
      imageSrc: pythonLogo,
    },
    {
      name: "Scrapy",
      url: "https://scrapy.org/",
      imageSrc: scrapy,
    },
    {
      name: "React-js",
      url: "https://es.reactjs.org/",
      imageSrc: reactLogo,
    },
    {
      name: "AWS",
      url: "https://aws.amazon.com/es/",
      imageSrc: aws,
    },
  ],
};
